<div class="vs-venue-host" [class.vs-venue-host--vertical]="direction === 'row'">
  <span class="vs-venue-host__picture" [style.background-image]="'url('+contactInfo?.detail.avatar+')'| imageRatio:avatarTransform:avatarWidth"></span>
  <div class="vs-venue-host__details">
    <em>{{ contactInfo?.detail.first_name }}</em>
    <strong>{{ venueName }}</strong>
  </div>
</div>
